import { ewbConfig } from "config";
import ReactGa from "react-ga4";

export const initializeAnalytics = () => {
  try {
    ReactGa.initialize(ewbConfig.googleAnalyticsTrackingID);

    console.log("ANALYTICS SUCCESS");
  } catch (e) {
    console.log("GOOGLE ANALYTICS TRACKING FAILED");
  }
};

export const trackPageView = () => {
  // ReactGa.pageview(pageName);
  try {
    ReactGa.send({
      hitType: "pageview",
      page: window.location.pathname,
    });
    console.log("Track");
  } catch (e) {
    console.error(e);
  }
};

export const trackPageViewByPageName = (pageName) => {
  try {
    ReactGa.send({
      hitType: "pageview",
      page: pageName,
    });
    console.log("Track", pageName);
  } catch (e) {
    console.error(e);
  }
};
export const eventTracker = (
  category = "No Category",
  action = "test action",
  label = "test label"
) => {
  try {
    ReactGa.event({ category, action, label });
    console.log("EVENT CAUGHT");
  } catch (e) {
    console.error("EVENT TRACKING FAILED", e);
  }
};

export const CATEGORIES = {
  MOBILE_CHECK_DEPOSIT: "MOBILE_CHECK_DEPOSIT",
  HOME_PAGE_CAROUSEL: "HOME_PAGE_CAROUSEL",
  DXP_LANDING_PAGE: "DXP_LANDING_PAGE",
};

export const ACTIONS = {
  ENTRY_POINT_FROM_CAROUSEL: "ENTRY_POINT_FROM_CAROUSEL",
  NAV_AFFIX_CLICK: "NAV_AFFIX_CLICK",
  CALL_TO_ACTION_CLICK: "BANNER_CALL_TO_ACTION_CLICK",
};

export const LABELS = {
  NAVIGATE_FROM_HOME_PAGE_CAROUSEL_TO: "NAVIGATE_FROM_HOME_PAGE_CAROUSEL_TO",
  NAV_AFFIX_SECTION_MENU: "NAV_AFFIX_SECTION_MENU",
  DXP_DOWNLOAD: "DXP_DOWNLOAD",
};
